import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import {
    Grid, Typography, Button, Autocomplete, TextField, Accordion, AccordionSummary, AccordionDetails, useMediaQuery, Divider,
    FormControlLabel, FormGroup, IconButton, Card, Stack, CardContent, Box, Tooltip, FormControl, InputLabel, Select, MenuItem,
    ListItemIcon, Checkbox, ListItemText, Dialog, DialogActions, DialogTitle, DialogContentText, DialogContent, FormHelperText,
    FormLabel, RadioGroup, Radio, Tab,Stepper, Step, StepLabel, styled
} from "@mui/material";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Check from '@mui/icons-material/Check';
import ServiceStep1 from '../Components/ServiceStep1';
import ServiceStep2 from '../Components/ServiceStep2';
import ServiceStep3 from '../Components/ServiceStep3';
import ServiceStep4 from '../Components/ServiceStep4';
import ServiceStep5 from '../Components/ServiceStep5';
import _ from 'lodash';

const steps = [
    'Get to Know You',
    'Video Strategy Builder',
    'Script Selection + Customization',
    'Tech & Shoot Prep',
    'Preview Requests'
    // 'Bonus Strategy Call',
  ];
  
  // Custom connector styling
  const ColorConnector = styled(StepConnector)(({ theme }) => ({
    
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
      left: 'calc(-50% + 13px)',
      right: 'calc(50% + 13px)',
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 8,
      border: 0,
      backgroundColor: '#2E6ECC',
      borderRadius: 1,
      borderTopWidth: 1,
      borderColor: theme.palette.primary.main, // optional
    },
    
  }));
  
  // Custom circle and number style
  const StepIconRoot = styled('div')(({ theme, ownerState }) => ({
    // backgroundColor: ownerState.completed ? '#6CC641' : '#2E6ECC',
    backgroundColor: ownerState.completed
    ? '#6CC641'
    : ownerState.active
    ? '#6CC641' // <-- example color for active step
    : '#2E6ECC',
    zIndex: 1,
    color: '#fff',
    width: 48,
    height:48,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
  }));
  
  function CustomStepIcon(props) {
    const { active, completed, className, icon } = props;
  
    return (
      <StepIconRoot ownerState={{ completed, active }} className={className}>
        {icon}
      </StepIconRoot>
    );
  }
function ServicesIndex({setTabValue,fetchMedia,fetchMediaService}) {
  const transformedVideo = fetchMedia?.video_config?.length
  ? fetchMedia.video_config.map((item) => ({
      id: item.media_service.id,
      title: item.media_service.service_name,
    }))
  : [];

  const transformedVideoData = fetchMedia?.video_config?.length
  ? fetchMedia.video_config.map((item) => ({
      service_id:item.media_service_id,
      template_id:item.template_id,
      title:item.media_service.service_name,
      video_script:item.video_script,
      selectedOption: item.video_script != "" ? "coaching" : "templates",
    }))
  : [];

  let parsedBusinessUrl = {};

  if (fetchMedia?.business_url) {
    try {
      let urlData = fetchMedia.business_url;

      // Parse once if it's a string
      if (typeof urlData === 'string') {
        urlData = JSON.parse(urlData); // this might still be a string (i.e., double-encoded)
      }

      // Parse again if needed
      if (typeof urlData === 'string') {
        urlData = JSON.parse(urlData);
      }

      parsedBusinessUrl = urlData;
    } catch (e) {
      console.error('Invalid business_url format:', e);
      parsedBusinessUrl = {};
    }
  }

  const [activeStep, setActiveStep] = useState(0);
  const [skippedToStep5, setSkippedToStep5] = useState(false);
  console.log("fetchMedia",fetchMedia);
  const [formData, setFormData] = useState({
    brand_name:fetchMedia.brand_name,
    business_url: fetchMedia.business_url,
    what_you_do: fetchMedia.what_you_do,
    company_master_id: fetchMedia.company_master_id,
    ideal_client: fetchMedia.ideal_client,
    camera_rating: fetchMedia.camera_rating,
    company_name: fetchMedia?.logo_config?.company_name,
    has_logo: fetchMedia.has_logo == 1 ? true : false,
    primary_color: fetchMedia?.logo_config?.primary_color,
    reference_image: "",
    secondary_color: fetchMedia?.logo_config?.secondary_color,
    suggestions: fetchMedia?.logo_config?.suggestions,
    tagline: fetchMedia?.logo_config?.tagline,
    video_data:transformedVideo,
    videos:transformedVideoData,
     selectedOptions: {
          website:  parsedBusinessUrl?.website ? true : false,
          instagram: parsedBusinessUrl?.instagram ? true : false,
          youtube: parsedBusinessUrl?.youtube ? true : false,
          other: parsedBusinessUrl?.other ? true : false,
      },
    websiteLink: parsedBusinessUrl.website,
    instagramLink: parsedBusinessUrl.instagram,
    youtubeLink: parsedBusinessUrl.youtube,
    otherLinks: parsedBusinessUrl.other || [''],
  });
  
  const formDataCopy = useRef(_.cloneDeep(formData));
  const isMobile = useMediaQuery('(max-width:600px)');
const handleNextStep = (stepData) => {
  setFormData(prev => ({ ...prev, ...stepData }));
  setActiveStep(prev => prev + 1);
};
const handlePreviousStep = () => {
  console.log("skippedToStep5",skippedToStep5);
   if (skippedToStep5) {
    
    setSkippedToStep5(false); // Reset skip flag
    setActiveStep(1);              // Go back to Step 2
  } else {
    setActiveStep(prev => prev - 1);
  }
  // setActiveStep(prev => prev - 1);

};
const handleSkipToStep5 = () => {
    setSkippedToStep5(true);
    setActiveStep(4); // Directly move to Step 5
  }

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return <ServiceStep1 onNext={handleNextStep} formData={formData} fetchMedia={fetchMedia} parsedBusinessUrl={parsedBusinessUrl} />;
      case 1:
        return <ServiceStep2 onNext={handleNextStep} formData={formData} onPrevious={handlePreviousStep}  transformedVideo={transformedVideo} onSkipToStep5={handleSkipToStep5} setSkippedToStep5={setSkippedToStep5}/>;
      case 2:
        return <ServiceStep3 onNext={handleNextStep} formData={formData} onPrevious={handlePreviousStep} transformedVideoData={transformedVideoData} />;
      case 3:
        return <ServiceStep4 onNext={handleNextStep} formData={formData} onPrevious={handlePreviousStep} fetchMedia={fetchMedia}/>;
      case 4:
        return <ServiceStep5 formData={formData} oldFormData={formDataCopy.current} setTabValue={setTabValue} fetchMedia={fetchMedia} onPrevious={handlePreviousStep} fetchMediaService={fetchMediaService} skippedToStep5={skippedToStep5}/>;
      default:
        return null;
    }
  };
    return (
        <>
        <Grid container item lg={12} md={12} sm={12} xs={12}>
            <Typography variant={isMobile ? "body2":'body1'} sx={{ textTransform: "capitalize"}} >
                <span style={{fontSize:isMobile?"20px":"25px"}}>Welcome! </span>
                Let's get your content rolling. Follow the 5 simple steps below so we can build high-impact videos that elevate your brand and attract more clients.
            </Typography>
        </Grid>
        <Stepper
      alternativeLabel
      activeStep={activeStep}
      connector={<ColorConnector />}
    >
      {steps.map((label, index) => (
        <Step key={label}
        sx={
          isMobile && index === 2
            ? { paddingRight: 0 } 
            : {}
        }>
          <StepLabel StepIconComponent={CustomStepIcon}
          >{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
    <Grid container mt={4}>
        {renderStepContent()}
      </Grid>
        {/* <ServiceStep1/>
        <ServiceStep2 />
        <ServiceStep3 />
        <ServiceStep4 />
        <ServiceStep5 /> */}
        </>
    )
}
export default ServicesIndex;